import axiosClient, { app_uri } from "../../../utils/axiosFactory";
import { TransactionClient, TransactionRepeatEnum } from "../../repsaApi";

const client = new TransactionClient(app_uri, axiosClient());

/**
 * Get transaction repeats with co-agent filter support
 */
export async function getTransactionRepeatsWithFilter(
  entity: TransactionRepeatEnum,
  coAgentIds?: number[],
): Promise<any> {
  const axios = axiosClient();
  let url = `${app_uri}/api/v1/Transaction/transaction-repeats?`;

  url += `entity=${encodeURIComponent(entity)}&`;

  if (coAgentIds && coAgentIds.length > 0) {
    url += `CoAgentIds=${encodeURIComponent(coAgentIds.join(","))}&`;
  }

  url = url.replace(/[?&]$/, "");

  const response = await axios.get(url);
  return response.data;
}

export default client;
